import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _assignCustomScheduleRequest = {};
var _assignCustomScheduleResponse = { staffMember: '_staffMember' };
var _assignWorkingHoursScheduleRequest = {};
var _assignWorkingHoursScheduleResponse = { staffMember: '_staffMember' };
var _bulkUpdateStaffMemberTagsByFilterRequest = {};
var _bulkUpdateStaffMemberTagsByFilterResponse = {};
var _bulkUpdateStaffMemberTagsRequest = {};
var _bulkUpdateStaffMemberTagsResponse = {};
var _connectStaffMemberToUserRequest = {};
var _connectStaffMemberToUserResponse = { staffMember: '_staffMember' };
var _countStaffMembersRequest = {};
var _countStaffMembersResponse = {};
var _createStaffMemberRequest = { staffMember: '_staffMember' };
var _createStaffMemberResponse = { staffMember: '_staffMember' };
var _deleteStaffMemberRequest = {};
var _deleteStaffMemberResponse = {};
var _disconnectStaffMemberFromUserRequest = {};
var _disconnectStaffMemberFromUserResponse = { staffMember: '_staffMember' };
var _getDeletedStaffMemberRequest = {};
var _getDeletedStaffMemberResponse = { staffMember: '_staffMember' };
var _getStaffMemberRequest = {};
var _getStaffMemberResponse = { staffMember: '_staffMember' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listDeletedStaffMembersRequest = {};
var _listDeletedStaffMembersResponse = { staffMembers: '_staffMember' };
var _mediaItem = { image: '_image' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultsScalarResult = { value: 'DOUBLE' };
var _nestedResultValue = {
    range: '_rangeResult',
    scalar: '_nestedResultsScalarResult',
};
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryStaffMembersMultiLanguageRequest = {};
var _queryStaffMembersMultiLanguageResponse = {
    staffMembers: '_staffMember',
    translatedStaffMembers: '_staffMember',
};
var _queryStaffMembersRequest = {};
var _queryStaffMembersResponse = { staffMembers: '_staffMember' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _removeStaffMemberFromTrashBinRequest = {};
var _removeStaffMemberFromTrashBinResponse = {};
var _restoreStaffMemberFromTrashBinRequest = {};
var _restoreStaffMemberFromTrashBinResponse = { staffMember: '_staffMember' };
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _searchStaffMembersRequest = {};
var _searchStaffMembersResponse = {
    staffMembers: '_staffMember',
    aggregationData: '_aggregationData',
};
var _staffMember = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    mainMedia: '_mediaItem',
};
var _updateStaffMemberRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    staffMember: '_staffMember',
};
var _updateStaffMemberResponse = { staffMember: '_staffMember' };
function resolveWixBookingsStaffV1StaffMembersServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/staff-members',
                destPath: '/v1/staff-members',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a staff member.
 *
 *
 * By default, the staff member works during the business working hours. You
 * could follow *this sample flow*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/sample-flows#backend-modules_bookings_staff-members_assign-a-staff-working-hour-schedule) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/sample-flows#assign-a-staff-working-hour-schedule))
 * to set custom working hours.
 */
export function createStaffMember(payload) {
    var _a = serializer(_createStaffMemberRequest, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __createStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.CreateStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createStaffMember.fromReq = fromReq;
    __createStaffMember.__isAmbassador = true;
    return __createStaffMember;
}
/** Retrieves a staff member. */
export function getStaffMember(payload) {
    var _a = serializer(_getStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __getStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'GET',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.GetStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStaffMember.fromReq = fromReq;
    __getStaffMember.__isAmbassador = true;
    return __getStaffMember;
}
/** Retrieves a deleted staff member from the trash-bin. */
export function getDeletedStaffMember(payload) {
    var _a = serializer(_getDeletedStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeletedStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __getDeletedStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'GET',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.GetDeletedStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDeletedStaffMember.fromReq = fromReq;
    __getDeletedStaffMember.__isAmbassador = true;
    return __getDeletedStaffMember;
}
/**
 * Retrieves a list of deleted staff members from the trash-bin.
 * List runs with these defaults, which you can override:
 * - `paging.limit` is `50`.
 */
export function listDeletedStaffMembers(payload) {
    var _a = serializer(_listDeletedStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDeletedStaffMembersResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __listDeletedStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'GET',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.ListDeletedStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDeletedStaffMembers.fromReq = fromReq;
    __listDeletedStaffMembers.__isAmbassador = true;
    return __listDeletedStaffMembers;
}
/**
 * Remove a staff member from the trash bin, permanently deleting it.
 * This action is irreversible.
 */
export function removeStaffMemberFromTrashBin(payload) {
    var _a = serializer(_removeStaffMemberFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeStaffMemberFromTrashBinResponse, {}).fromJSON;
    function __removeStaffMemberFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'DELETE',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.RemoveStaffMemberFromTrashBin',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeStaffMemberFromTrashBin.fromReq = fromReq;
    __removeStaffMemberFromTrashBin.__isAmbassador = true;
    return __removeStaffMemberFromTrashBin;
}
/**
 * Restore a staff member from the trash bin.
 * This action also restores the staff member's resource.
 */
export function restoreStaffMemberFromTrashBin(payload) {
    var _a = serializer(_restoreStaffMemberFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreStaffMemberFromTrashBinResponse, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }).fromJSON;
    function __restoreStaffMemberFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.RestoreStaffMemberFromTrashBin',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin/{staffMemberId}/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreStaffMemberFromTrashBin.fromReq = fromReq;
    __restoreStaffMemberFromTrashBin.__isAmbassador = true;
    return __restoreStaffMemberFromTrashBin;
}
/**
 * Updates a staff member.
 *
 *
 * Each time the staff member is updated, `revision` increments by 1. You must
 * include current revision of the staff member when updating it. This ensures
 * you're working with the latest service information and prevents unintended
 * overwrites.
 */
export function updateStaffMember(payload) {
    var _a = serializer(_updateStaffMemberRequest, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __updateStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'PATCH',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.UpdateStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMember.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStaffMember.fromReq = fromReq;
    __updateStaffMember.__isAmbassador = true;
    return __updateStaffMember;
}
/**
 * Deletes a staff member.
 *
 *
 * Also deletes the *resource*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/resources/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resources-v2/introduction))
 * associated with the staff member.
 */
export function deleteStaffMember(payload) {
    var _a = serializer(_deleteStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteStaffMemberResponse, {}).fromJSON;
    function __deleteStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'DELETE',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.DeleteStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteStaffMember.fromReq = fromReq;
    __deleteStaffMember.__isAmbassador = true;
    return __deleteStaffMember;
}
/**
 * Retrieves a list of up to 100 staff members, given the provided paging,
 * filtering, and sorting.
 *
 *
 * ## Defaults
 *
 * Query Staff Members has the following default settings, which you can override:
 * + Sorted by `createdDate` in ascending order.
 * + `cursorPaging.limit` set to `100`.
 *
 * ## Filter
 *
 * Refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/filtering-and-sorting))
 * for a complete list of supported filters and sorting options.
 *
 * ## See also
 *
 * To learn about working with *Query* methods, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function queryStaffMembers(payload) {
    var _a = serializer(_queryStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStaffMembersResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __queryStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.QueryStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStaffMembers.fromReq = fromReq;
    __queryStaffMembers.__isAmbassador = true;
    return __queryStaffMembers;
}
/**
 * Query staff members in multiple languages.
 *
 * Supports responses with text values (such as translated description) in different languages.
 */
export function queryStaffMembersMultiLanguage(payload) {
    var _a = serializer(_queryStaffMembersMultiLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStaffMembersMultiLanguageResponse, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }).fromJSON;
    function __queryStaffMembersMultiLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.QueryStaffMembersMultiLanguage',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/query-multi-language',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStaffMembersMultiLanguage.fromReq = fromReq;
    __queryStaffMembersMultiLanguage.__isAmbassador = true;
    return __queryStaffMembersMultiLanguage;
}
/**
 * Counts how many staff members match the given filter.
 *
 *
 * ## Filter
 *
 * Refer to the _supported filters article_
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/supported-filters) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/filtering-and-sorting))
 * for a complete list of supported filters and sorting options.
 *
 * ## See also
 *
 * To learn about working with filters in general, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
 */
export function countStaffMembers(payload) {
    var _a = serializer(_countStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countStaffMembersResponse, {}).fromJSON;
    function __countStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.CountStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countStaffMembers.fromReq = fromReq;
    __countStaffMembers.__isAmbassador = true;
    return __countStaffMembers;
}
/**
 * Connects a Wix user to a staff member, enabling them to manage their own
 * working hour schedule in the dashboard.
 *
 *
 * By default, Wix Bookings uses the staff member's `email`. However, you can
 * specify an alternative email address. If no existing Wix user is associated
 * with that email, Wix sends them an invitation to become a Wix user. If an
 * existing user is found but not linked to the site, Wix Bookings sends an
 * invitation to join the site.
 *
 * To check the connection status, call *Get Staff Member*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/get-staff-member) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/get-staff-member)),
 * and specify `ASSOCIATED_IDENTITY_STATUS` in the `fields` parameter.
 *
 * You must call *Disconnect Staff Member From User*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/disconnect-staff-member-from-user) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/disconnect-staff-member-from-user))
 * before connecting a different Wix user to the staff member.
 */
export function connectStaffMemberToUser(payload) {
    var _a = serializer(_connectStaffMemberToUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_connectStaffMemberToUserResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __connectStaffMemberToUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.ConnectStaffMemberToUser',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/connect-staff-member-to-user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __connectStaffMemberToUser.fromReq = fromReq;
    __connectStaffMemberToUser.__isAmbassador = true;
    return __connectStaffMemberToUser;
}
/**
 * Retrieves a list of up to 100 staff members, given the provided filtering, paging,
 * and sorting.
 *
 *
 * ## Defaults
 *
 * Search Staff Members has the following default settings, which you can override:
 * + Sorted by `createdDate` in ascending order.
 * + `cursorPaging.limit` set to `100`.
 *
 * ## Filter
 *
 * Refer to the _supported filters article_
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/supported-filters) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/filtering-and-sorting))
 * for a complete list of supported filters and sorting options.
 *
 * ## See also
 *
 * To learn about working with *Search* methods, see
 * _API Query Language_
 * ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language))
 * and _Sorting and Paging_
 * ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-sort-array) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging)).
 */
export function searchStaffMembers(payload) {
    var _a = serializer(_searchStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchStaffMembersResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _groupByValueResults: _groupByValueResults,
        _image: _image,
        _mediaItem: _mediaItem,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedResultsScalarResult: _nestedResultsScalarResult,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
        _staffMember: _staffMember,
    }).fromJSON;
    function __searchStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.SearchStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchStaffMembers.fromReq = fromReq;
    __searchStaffMembers.__isAmbassador = true;
    return __searchStaffMembers;
}
/**
 * Disconnects a staff member from a Wix user, clearing the `associatedWixIdentity`
 * field. Consequently, the user can no longer manage the staff member's working
 * hour schedule in the dashboard.
 *
 *
 * You must call *Disconnect Staff Member From User* before connecting a
 * different Wix user to the staff member.
 */
export function disconnectStaffMemberFromUser(payload) {
    var _a = serializer(_disconnectStaffMemberFromUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disconnectStaffMemberFromUserResponse, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }).fromJSON;
    function __disconnectStaffMemberFromUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.DisconnectStaffMemberFromUser',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/disconnect-staff-member-from-user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disconnectStaffMemberFromUser.fromReq = fromReq;
    __disconnectStaffMemberFromUser.__isAmbassador = true;
    return __disconnectStaffMemberFromUser;
}
/**
 * Updates a staff member's working hours based on the specified *schedule ID*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction)).
 *
 *
 * ## Default working hours
 *
 * By default, staff members work during the opening hours of the business's
 * _default location_
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)).
 *
 * ## Schedule ID
 *
 * You can specify either the ID of the business's working hour schedule or the
 * staff member's event schedule. The call fails if you specify a different
 * schedule ID.
 *
 * ### Staff event schedule
 *
 * To customize a staff member's working hours, specify their event schedule ID
 * as `scheduleId`. Refer to *this sample flow*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/sample-flows#backend-modules_bookings_staff-members_assign-a-staff-working-hour-schedule) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/sample-flows#assign-a-staff-working-hour-schedule))
 * for more details.
 *
 * ### Business working hour schedule
 *
 * To reset a staff member’s working hours to the default business hours,
 * specify the ID of the business working hour schedule as `scheduleId`.
 */
export function assignWorkingHoursSchedule(payload) {
    var _a = serializer(_assignWorkingHoursScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignWorkingHoursScheduleResponse, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }).fromJSON;
    function __assignWorkingHoursSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.AssignWorkingHoursSchedule',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/assign-working-hours-schedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignWorkingHoursSchedule.fromReq = fromReq;
    __assignWorkingHoursSchedule.__isAmbassador = true;
    return __assignWorkingHoursSchedule;
}
/**
 * Assigns a custom working hours schedule to the staff member
 *
 *
 * The working hours schedule is a schedule that defines the working hours of a staff member,
 * and dictate when the staff member is available for bookings.
 *
 * By default staff members use the shared business working hours schedule. By assigning a custom working hours schedule to a staff member,
 * you can define specific working hours for that staff member.
 *
 * To create and manage schedules and working hours sessions, use [Events API](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction).
 * @deprecated It has been replaced with wix.bookings.staff.v1.StaffMembersService.AssignWorkingHoursSchedule(), and will be removed on 2024-12-31.
 */
export function assignCustomSchedule(payload) {
    var _a = serializer(_assignCustomScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignCustomScheduleResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __assignCustomSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.AssignCustomSchedule',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/assign-custom-schedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignCustomSchedule.fromReq = fromReq;
    __assignCustomSchedule.__isAmbassador = true;
    return __assignCustomSchedule;
}
/**
 * Synchronously updates *tags*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/tags/tags/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/tags/introduction)).
 * for up to 100 staff members.
 *
 *
 * If you specify a tag both in `assignTags` and `unassignTags`, the call
 * succeeds and the tag is assigned.
 */
export function bulkUpdateStaffMemberTags(payload) {
    var _a = serializer(_bulkUpdateStaffMemberTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateStaffMemberTagsResponse, {}).fromJSON;
    function __bulkUpdateStaffMemberTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.BulkUpdateStaffMemberTags',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/bulk/staff-members/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateStaffMemberTags.fromReq = fromReq;
    __bulkUpdateStaffMemberTags.__isAmbassador = true;
    return __bulkUpdateStaffMemberTags;
}
/**
 * Asynchronously updates *tags*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/tags/tags/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/tags/introduction)).
 * for staff members, given the provided filtering.
 *
 *
 * If you specify a tag both in `assignTags` and `unassignTags`, the call
 * succeeds and the tag is assigned.
 *
 * ## Filter
 *
 * Refer to the supported filters article
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/filtering-and-sorting))
 * for a complete list of supported filters and sorting options.
 */
export function bulkUpdateStaffMemberTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateStaffMemberTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateStaffMemberTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateStaffMemberTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.BulkUpdateStaffMemberTagsByFilter',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/bulk/staff-members/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateStaffMemberTagsByFilter.fromReq = fromReq;
    __bulkUpdateStaffMemberTagsByFilter.__isAmbassador = true;
    return __bulkUpdateStaffMemberTagsByFilter;
}
//# sourceMappingURL=http.impl.js.map